<template>
    <button class="btn btn-danger">
        <slot />
    </button>
</template>
